import * as tslib_1 from "tslib";
import * as assign from 'object-assign';
import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import setMailboxCalendarConfiguration from '../services/setMailboxCalendarConfiguration';
export default action('saveCalendarMailboxConfiguration')(function saveCalendarMailboxConfiguration(mailboxCalendarConfiguration) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    assign(store.calendarConfiguration, mailboxCalendarConfiguration);
                    return [4 /*yield*/, setMailboxCalendarConfiguration(mailboxCalendarConfiguration)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=saveCalendarMailboxConfiguration.js.map